import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Mail, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function ClientLogin() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/client/request-link", { email });
      setSent(true);
    } catch (err) { setError(formatApiError(err)); }
    finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--fb-bg)" }}>
      <div className="max-w-md w-full fb-card p-6 sm:p-8 md:p-10">
        <div className="flex items-center gap-3 mb-8">
          <Logo size={44} />
          <div>
            <div className="font-bold" style={{ fontFamily: "Outfit" }}>Pullman Child Welfare</div>
            <div className="text-xs" style={{ color: "var(--fb-text-muted)" }}>Client Portal</div>
          </div>
        </div>

        {!sent ? (
          <>
            <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "Outfit" }}>Sign in or sign up</h1>
            <p className="text-sm mb-6" style={{ color: "var(--fb-text-muted)" }}>
              Enter your email to sign in or set up a new account. We'll email you a one-time link.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <div className="relative">
                  <Mail className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2" style={{ color: "#8B918B" }} />
                  <input
                    data-testid="client-email-input"
                    type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    className="w-full pl-10 pr-3 py-3 rounded-lg border-2 outline-none focus:border-[#052F66]"
                    style={{ borderColor: "var(--fb-border)", background: "#FAFAF8" }}
                  />
                </div>
              </div>
              {error && <div className="fb-status-error text-sm p-3 rounded-lg">{error}</div>}
              <button data-testid="send-link-btn" type="submit" disabled={loading}
                      className="w-full fb-btn-primary py-3 rounded-lg font-semibold">
                {loading ? "Sending…" : "Send sign-in link"}
              </button>
            </form>
            <div className="mt-6 text-center text-sm">
              <Link to="/login" className="font-medium underline" style={{ color: "var(--fb-text-muted)" }} data-testid="staff-link">Staff sign in</Link>
            </div>
          </>
        ) : (
          <div className="text-center py-4" data-testid="link-sent-confirmation">
            <div className="w-14 h-14 rounded-full mx-auto mb-4 flex items-center justify-center fb-status-success">
              <CheckCircle2 className="w-7 h-7" />
            </div>
            <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: "Outfit" }}>Check your email</h2>
            <p className="text-sm" style={{ color: "var(--fb-text-muted)" }}>
              A one-time link has been sent to <strong>{email}</strong>. It expires in 15 minutes.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
